import { extend } from 'lodash';

export class CtxType {
    ID: number;
    Name: string;
    CreatedAt: string;
    LastModifiedAt: string;
    DeletedAt: string;

    public static fromJSON(params: any = {}): CtxType {
        const frequency = extend(new CtxType(), params);
        return frequency;
    }
}
export class CtxTypes {
    Frequency: CtxType[];
    TotalCount: number;
}
